import React from 'react';

import starsBackground from 'assets/img/2026/estrelas_fundo.png';
import logoPremio from 'assets/img/2026/logo_premio.png';
import seloEuParticipo from 'assets/img/2026/selo_eu_participo.png';

interface ParticipationConfirmedModalProps {
  onClose: () => void;
}

export function ParticipationConfirmedModal({ onClose }: ParticipationConfirmedModalProps) {
  return (
    <div
      className="participation-confirmed-card relative w-full max-w-[430px] overflow-hidden rounded-[24px] bg-blue-bb-1 px-4 py-4 text-center md:px-5 md:py-5"
      style={{ backgroundImage: `url(${starsBackground})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <img src={logoPremio} alt="Logo Prêmio BB" className="mx-auto mb-2 w-[56px] object-contain md:w-[64px]" />

      <h2 className="m-0 text-[1.8rem] font-bold leading-tight text-pink-bb-1 md:text-[2rem]">Participação confirmada!</h2>

      <p className="mt-2 mb-0 text-[1.8rem] font-bold leading-[1.18] text-white md:text-[1.95rem]">
        Agora você faz parte do <span className="text-yellow-bb">Prêmio BB 2026</span> e já pode exibir com orgulho o seu selo{' '}
        <span className="text-green-bb-2">“Eu participo”.</span>
      </p>

      <p className="mt-2 mb-0 text-[1rem] font-bold leading-[1.28] text-white md:text-[1.05rem]">
        Use o selo na sua foto de perfil, baixe para compartilhar e espalhe essa conquista!
      </p>

      <div className="relative mx-auto mt-3 h-[148px] w-[148px] md:h-[164px] md:w-[164px]">
        <img
          src={seloEuParticipo}
          alt="Selo Eu participo"
          className="absolute left-1/2 top-1/2 w-[240px] -translate-x-1/2 -translate-y-1/2 object-contain md:w-[240px]"
        />
      </div>

      <a
        href={seloEuParticipo}
        download="selo-eu-participo-premio-bb-2026.png"
        className="mt-2 inline-block text-base font-semibold text-white underline md:text-lg"
      >
        Baixar selo
      </a>

      <div className="mt-3">
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg border-0 bg-yellow-bb px-5 py-2 text-sm font-extrabold text-blue-bb-1 md:text-base"
        >
          Fechar
        </button>
      </div>
    </div>
  );
}
